module.exports = __webpack_public_path__ + "img/ddz.10212e80.jpg";